var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIolabsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "-22.211 1306.305 788.834 192",
    height: 192,
    width: 788.834,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.733 1443.394c0 3.253-.038 6.529.023 9.789.023.994-.209 1.334-1.287 1.334-6.876-.055-13.782-.055-20.674-.016-.994.008-1.233-.316-1.233-1.271.022-40.052.015-80.104.022-120.155 0-.339.023-.686.039-1.118h24.327v44.53c.339-.3.509-.393.586-.523 3.992-5.937 9.666-9.351 16.418-11.231 8.727-2.428 17.328-2.243 25.622 1.696 6.939 3.261 12.057 8.471 15.772 15.093 4.455 7.924 6.306 16.534 6.528 25.521.146 6.128-.076 12.225-1.518 18.215-2.56 10.545-7.47 19.646-16.712 25.838-6.575 4.393-13.905 6.012-21.768 5.473-5.01-.348-9.882-1.211-14.536-3.138-4.533-1.881-8.095-4.918-10.639-9.118-.2-.355-.424-.694-.64-1.041l-.33.122zm41.917-33.338c-.153-1.936-.246-3.877-.433-5.805-.501-4.74-1.702-9.258-4.191-13.382-5.026-8.354-13.443-11-22.153-8.378-6.082 1.819-9.743 6.336-12.063 12.018-2.259 5.487-2.931 11.283-2.729 17.174.2 5.635 1.156 11.131 3.784 16.232 4.363 8.44 12.703 12.317 21.922 10.045 6.074-1.488 9.905-5.636 12.503-11.069 2.503-5.32 3.251-11.015 3.36-16.835",
    clipPath: "url(#b)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.029 1454.309h-1.202c-7.322 0-14.645-.017-21.982.03-.948.008-1.48-.186-1.682-1.24-.432-2.305-.971-4.617-1.479-6.978-.116.056-.301.115-.433.247-5.104 5.063-11.369 7.777-18.329 9.104-7.338 1.389-14.701 1.635-21.993-.262-9.377-2.459-15.994-7.971-18.303-17.676-1.519-6.413-1.403-12.888 1.418-18.984 3.176-6.853 8.938-10.691 16.014-12.765 6.174-1.813 12.514-2.735 18.893-3.547 4.772-.624 9.521-1.479 14.269-2.28.777-.132 1.557-.517 2.297-.832 4.378-1.92 5.78-4.625 5.272-9.396-.686-6.344-4.995-9.242-10.452-9.874-3.978-.438-7.924-.57-11.823.509-5.793 1.58-8.568 5.249-9.404 11.178-.158 1.155-.52 1.457-1.649 1.448-7.246-.039-14.487-.022-21.741-.022h-1.137c.135-3.615.756-7.038 2.135-10.268 2.987-7.015 8.298-11.724 15.108-14.892 5.188-2.39 10.691-3.5 16.318-4.101 6.043-.655 12.063-.532 18.083.054 6.876.64 13.536 2.127 19.394 6.043 6.184 4.124 9.481 9.928 9.527 17.375.085 16.395 0 32.791.063 49.202 0 4.662.309 9.342 1.456 13.89.314 1.3.853 2.563 1.362 4.037m-27.357-43.034c-1.057.539-2.012 1.155-3.045 1.541-3.592 1.342-7.354 1.936-11.146 2.39-4.17.51-8.34 1.096-12.279 2.599-4.251 1.618-7.234 4.409-7.909 9.126-.878 6.175 1.638 11.309 8.414 12.826 4.113.918 8.275.94 12.391.153 5.057-.979 8.895-3.775 11.353-8.348 1.488-2.76 2.136-5.766 2.197-8.872.079-3.769.024-7.531.024-11.415",
    clipPath: "url(#d)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.232 1410.38c-.077-9.104 1.564-17.545 5.815-25.36 5.408-9.958 13.698-16.464 24.478-19.655 11.443-3.398 22.932-3.145 34.159 1.079 11.627 4.362 19.579 12.572 23.98 24.165 3.095 8.141 3.754 16.588 3.048 25.175-.593 7.323-2.586 14.229-6.351 20.559-5.527 9.296-13.651 15.216-23.938 18.236-6.725 1.989-13.608 2.405-20.577 1.857-7.461-.608-14.468-2.612-20.843-6.575-8.556-5.334-14.114-12.996-17.251-22.508-1.849-5.604-2.582-11.362-2.52-16.973m67.619-.27c-.393-3.354-.655-6.737-1.222-10.06-.802-4.719-2.563-9.08-5.962-12.572-5.896-6.066-13.177-7.061-20.943-5.064-6.398 1.657-10.472 6.221-12.657 12.265-3.272 9.088-3.265 18.398-1.018 27.71 1.087 4.523 3.199 8.518 6.741 11.654 4.004 3.537 8.787 4.609 13.982 4.494 8.125-.209 14.029-3.869 17.567-11.216 2.599-5.425 3.193-11.26 3.512-17.211",
    clipPath: "url(#f)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M604.195 1391.441c-.447.031-.755.069-1.056.069-7.008 0-14.029 0-21.052.016-.654 0-1.095-.077-1.164-.886-.548-6.074-4.302-9.119-9.921-10.36-4.771-1.063-9.572-1.147-14.313.208-4.51 1.318-6.607 4.818-5.666 9.058.523 2.313 2.158 3.738 4.063 4.879 3.275 2.004 6.953 2.866 10.622 3.746 6.922 1.681 13.874 3.222 20.742 5.019 4.987 1.303 9.604 3.469 13.466 6.977 4.278 3.885 6.498 8.726 6.637 14.536.108 4.727-.36 9.352-2.357 13.69-2.982 6.467-7.924 10.969-14.321 13.943-4.726 2.205-9.751 3.184-14.868 3.801-5.157.607-10.329.725-15.493.246-8.024-.756-15.794-2.345-22.577-7.021-7.315-5.042-11.539-11.964-12.311-20.89-.085-.863-.169-1.75-.276-2.698h23.055c.178 1.18.263 2.39.571 3.538 1.364 5.103 4.833 8.271 9.704 9.913 5.666 1.904 11.385 1.896 17.051-.17 2.272-.81 4.224-2.135 5.711-4.077 3.169-4.255 2.189-9.651-2.327-12.426-3.399-2.073-7.238-3.052-11.038-4.047-7.354-1.967-14.784-3.669-22.13-5.682-4.772-1.295-9.135-3.5-12.773-6.991-4.655-4.433-6.073-9.981-5.682-16.172.224-3.422.74-6.791 2.213-9.959 2.605-5.558 6.854-9.458 12.355-12.079 4.795-2.281 9.896-3.337 15.178-3.938 6.021-.701 12.023-.709 18.037.054 7.691.987 14.931 3.13 20.866 8.434 5.163 4.616 8.009 10.429 8.81 17.273.015.316.054.617.1.925.027.316.073.616.144 1.071",
    clipPath: "url(#h)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.545 1431.823h59.665v22.433c-.424.021-.836.054-1.241.054-27.98 0-55.954-.008-83.926.03-1.099 0-1.449-.254-1.449-1.41.039-39.891.039-79.787 0-119.678 0-1.147.362-1.402 1.457-1.402 7.981.039 15.975.022 23.957.031 1.53 0 1.538 0 1.538 1.525v98.417h-.001z",
    clipPath: "url(#j)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.943 1454.255H92.681v-1.28c0-28.651 0-57.256-.023-85.892-.007-1.041.216-1.411 1.33-1.403 7.292.054 14.568.022 21.86.03.339 0 .679.031 1.095.055v88.49z",
    clipPath: "url(#l)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.693 1475.552v-8.278h85.538c.039.263.096.485.096.717.008 2.476.008 4.973.008 7.563l-85.642-.002z",
    clipPath: "url(#n)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M-12.362 1311.669h751.61v174.004h-751.61z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#p)",
    d: "M92.747 1331.942h24.177v20.019H92.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED1C24",
    d: "M632.407 1364.169h92.082v92.065h-92.082z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M687.05 1401.53v-20.164h-17.143v20.164h-20.165v17.144h20.165v20.164h17.143v-20.164h20.163v-17.144z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIolabsBlack);
export default __webpack_public_path__ + "static/media/logo-iolabs-black.e8c4bf6ec6417af151b726808fc161eb.svg";
export { ForwardRef as ReactComponent };